import React from 'react';
import { Play } from 'react-feather';

interface IVideoCardProps {
  title: string;
  description: string;
  category: string;
  duration: string;
  thumbnail: string;
  isNew?: boolean;
  onClick?: () => void;
}

const VideoCard: React.FC<IVideoCardProps> = ({
  title,
  description,
  category,
  duration,
  thumbnail,
  isNew = false,
  onClick
}) => {
  return (
    <div className="kh-video-card" onClick={onClick}>
      <div className="kh-video-card__thumbnail">
        {isNew && <span className="kh-video-card__badge">New</span>}
        <img src={thumbnail} alt={title} />
        <div className="kh-video-card__overlay">
          <button className="kh-video-card__play-btn" aria-label="Play video">
            <Play size={24} />
          </button>
        </div>
        <span className="kh-video-card__duration">{duration}</span>
      </div>
      <div className="kh-video-card__content">
        <span className="kh-video-card__category">{category}</span>
        <h3 className="kh-video-card__title">{title}</h3>
        <p className="kh-video-card__description">{description}</p>
      </div>
    </div>
  );
};

export default VideoCard;
